// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 PRO React examples
import SimpleInfoCard from "custom/Cards/InfoCards/SimpleInfoCard";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

function Information() {
  return (
    <MKBox component="section" py={6} mt={6}>
      <Container>
        <Grid container spacing={3} item xs={12} lg={8} mx="auto">
          <MKTypography variant="h3" mb={7}>
            ¿Qué es la Prueba de Penetración Externa?
          </MKTypography>
          <MKTypography variant="body2" align="justify">
            La prueba de penetración externa, a menudo denominada prueba de red externa o evaluación externa, es un proceso metódico diseñado para simular ciberataques externos en los activos digitales de una organización, como sitios web, aplicaciones e infraestructura de red. Su objetivo principal es identificar vulnerabilidades y debilidades que podrían ser explotadas por actores externos malintencionados.
          </MKTypography>
          <MKTypography variant="h3" mb={7} mt={7}>
            Aspectos Clave de la Prueba de Penetración Externa
          </MKTypography>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="my_location"
                title="Definición del Alcance y Objetivos"
                description="El alcance de la prueba de penetración externa se define meticulosamente para evaluar activos específicos, como sitios web públicos, aplicaciones web o infraestructura de red externa. Esto asegura que las pruebas estén alineadas con los objetivos de seguridad de la organización."
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="public"
                title="Simulaciones Realistas"
                description="Los evaluadores de penetración externa utilizan técnicas y tácticas similares a las utilizadas por atacantes externos genuinos, intentando explotar vulnerabilidades identificadas para obtener acceso no autorizado o comprometer datos."
              />
            </Grid>
          </Grid>
          <Grid container spacing={3} sx={{ mt: { xs: 0, md: 1 } }}>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="analytics"
                title="Evaluación de Riesgos"
                description="Los resultados de la prueba de penetración externa ayudan a las organizaciones a evaluar sus riesgos y vulnerabilidades de seguridad externa. Cada hallazgo se clasifica por gravedad, lo que permite a las organizaciones priorizar los esfuerzos de remediación."
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="pentagon"
                title="Informes Exhaustivos"
                description="Los evaluadores de penetración externa a menudo proporcionan orientación y apoyo a las organizaciones para abordar y remediar las vulnerabilidades identificadas, ayudando a mejorar la postura general de seguridad."
              />
            </Grid>
          </Grid>
          <Grid container spacing={3} sx={{ mt: { xs: 0, md: 1 } }}>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="description"
                title="Guía de Remediación"
                description="Los resultados de la prueba de penetración externa ayudan a las organizaciones a evaluar sus riesgos y vulnerabilidades de seguridad externa. Cada hallazgo se clasifica por gravedad, lo que permite a las organizaciones priorizar los esfuerzos de remediación."
              />
            </Grid>
            <Grid item xs={12} md={6}>
            </Grid>
          </Grid>
          <MKTypography variant="h3" mb={7} mt={7}>
            ¿Por qué Importa la Prueba de Penetración Externa?
          </MKTypography>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="output_circle"
                title="Mitigación de Amenazas Externas"
                description="Ayuda a las organizaciones a identificar y remediar vulnerabilidades externas que podrían ser explotadas por ciberdelincuentes, hackers u otras entidades externas malintencionadas."
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="trending_down"
                title="Reducción de Riesgos"
                description="Identificar y abordar proactivamente las vulnerabilidades en los activos externos reduce el riesgo de brechas de datos, acceso no autorizado y ataques externos."
              />
            </Grid>
          </Grid>
          <Grid container spacing={3} sx={{ mt: { xs: 0, md: 1 } }}>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="gavel"
                title="Cumplimiento y Garantía"
                description="Muchas industrias y organismos reguladores exigen evaluaciones de seguridad regulares, incluida la prueba de penetración externa, para demostrar el cumplimiento y el compromiso con prácticas robustas de ciberseguridad."
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="restart_alt"
                title="Mejora Continua"
                description="Los evaluadores de penetración externa a menudo proporcionan orientación y apoyo a las organizaciones para abordar y remediar las vulnerabilidades identificadas, ayudando a mejorar la postura general de seguridad."
              />
            </Grid>
          </Grid>
          <MKTypography variant="h3" mb={7} mt={7}>
            El Rol de la Prueba de Penetración Externa en la Ciberseguridad
          </MKTypography>
          <MKTypography variant="body2" align="justify">
            La prueba de penetración externa es un componente crítico de una estrategia integral de ciberseguridad. Ayuda a las organizaciones a fortalecer sus defensas externas, asegurando que su perímetro digital permanezca resiliente ante amenazas externas. Al invertir en servicios de prueba de penetración externa, las organizaciones pueden mantener la confianza en su presencia digital y proteger datos sensibles de adversarios externos en un mundo digital cada vez más conectado.
          </MKTypography>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Information;